export const STATISTICS_CSV_HEADERS = {
  SPORT_ID: 'Sport ID',
  SPORT_NAME: 'Sport Name',
  TOTAL_VIEWS: 'Total Views',
  TOTAL_BYTES: 'Total Bytes',
  TOTAL_DURATON: 'Total Duration',
  AVERAGE_DURATION: 'Average Duration',
  PERCENTAGE_VIEWS: 'Percentage Views',
  UNIQUE_VIEWS: 'Unique Views',
  PERIOD_START: 'Period Start',
  USER_AGENT: 'User Agent',
  OPERATOR_NAME: 'Operator Name',
  STREAM_NAME: 'Stream Name',
  LOCATION: 'Country',
  STATE_NAME: 'State',
  PROVINCE_NAME: 'Province'
} as const

export type StatisticsCsvHeaders = ValueOf<typeof STATISTICS_CSV_HEADERS>
